import { AbstractControl, ValidatorFn } from '@angular/forms';

const ContactPersonInvalidFormError = 'invalidAutocompleteObject';

export class CustomValidators {
    static isWholeNumberValidator: ValidatorFn = ({ value }: AbstractControl) => {
        const isDecimal = /\.\d/.test(value);

        return isDecimal ? { invalid: true } : null;
    };

    static hasSelectedValueValidator = (): ValidatorFn => {
        return (control: AbstractControl): { [key: string]: unknown } | null => {
            if (typeof control.value === 'string') {
                return { [ContactPersonInvalidFormError]: { value: control.value } };
            }

            return null;
        };
    };
}